import type { ObservableQuery } from '@apollo/client';
import { InvariantError } from '@apollo/client/utilities/invariant';
import { onlyCompleteData } from 'apollo-angular';
import { filter, of, pipe, switchMap, throwError } from 'rxjs';

export function throwErrorOrCompleteData<TData>() {
  return pipe(
    // Ignore query results with an `InvariantError`, as this happens when the store is reset during an in-flight query,
    // however the request will be restarted and the observable emits a value. Without this filter, the QD won't load.
    filter((res: ObservableQuery.Result<TData>) => !res.error || !(res.error instanceof InvariantError)),
    switchMap((res: ObservableQuery.Result<TData>) => {
      if (res.error) {
        return throwError(() => res.error);
      }

      return of(res);
    }),
    onlyCompleteData(),
  );
}
